import { useParams } from "react-router-dom";
import { ProductDetailsForm, ProductDetailsPageHeader } from "./components";
import { useProductDetails } from "@hooks/inventory/procurements/useProductDetails";

export const ProductDetails = () => {
  const params = useParams();
  const { id2 } = params || {};

  const { getData } = useProductDetails(id2 || "");

  return (
    <div className="p-10">
      <ProductDetailsPageHeader productDetails={getData} />
      <ProductDetailsForm productDetails={getData} />
    </div>
  );
};

export default ProductDetails;
